const MEDIA_SELECTOR = "img, svg, video, audio, iframe, canvas"

export function removeEmptyListItems(html) {
    if (typeof html !== "string" || !html.includes("<li")) return html

    const container = document.createElement("div")
    container.innerHTML = html

    let removedAny = true
    while (removedAny) {
        removedAny = false
        for (const li of [...container.querySelectorAll("li")]) {
            if (li.querySelector("li")) continue
            const hasMedia = li.querySelector(MEDIA_SELECTOR)
            const text = li.textContent.replace(/\u200B/g, "").trim()
            if (!text && !hasMedia) {
                li.remove()
                removedAny = true
            }
        }
    }

    return container.innerHTML
}
